import { isMissingRequiredSelection } from './is-missing-required-selection.js';

const getNotification = (selectedFacets, treeLevelVariants, facetConfig, activeFacet, notificationType)=>{
    const missingRequiredSelection = isMissingRequiredSelection(selectedFacets, treeLevelVariants, facetConfig, activeFacet);
    if (!activeFacet && facetConfig.notification && missingRequiredSelection && notificationType) {
        return facetConfig === null || facetConfig === void 0 ? void 0 : facetConfig.notification;
    } else {
        return null;
    }
};

export { getNotification };
//# sourceMappingURL=get-notification.js.map
